import { Component } from '@angular/core';

@Component({
  selector: 'app-ui-edit-details',
  templateUrl: './ui-edit-details.component.html',
  styleUrls: ['./ui-edit-details.component.scss']
})
export class UiEditDetailsComponent {

}
